module.exports = __webpack_public_path__ + "static/media/Error_404.eedf3d89.svg";